import { createTheme } from '@mui/material/styles';

const agent = () => {
    try {
        return JSON.parse(sessionStorage.getItem('user')) || {};
    } catch {
        return {};
    }
}

const theme = createTheme({
    status: {
      danger: '#e53e3e',
      error: '#96031A'
    },
    typography:{
      fontFamily: 'Roboto, sans-serif',
      h1:{
        fontSize:36,
      },
      h2:{
        fontSize:32,
      },
      h3:{
        fontSize:28,
      },
      h4:{
        fontSize:22,
      },
      h5:{
        fontSize: 20
      },
      subtitle1:{
        fontSize:16,
        fontWeight:'bold'
      },
      body1:{
        fontSize:15
      },
      info:{
        fontSize:13
      }
    },
    palette: {
      primary: {
        main: agent.role==='gestionnaire'? '#4682B4': '#255760', //rgb blue: 70, 130, 180
        darker: '#1B3E45',
        background:'rgba(37, 87, 96,0.5)'
      },
      warning: {
        main: '#D5A021',
      },
      action:{
        hover: 'rgba(37, 87, 96, 0.1)'
      },
      neutral: {
        main: '#fff',
        contrastText: '#000',
      },
      turquoise: {
        main: '#79E1D5',
        contrastText: '#FFF'
      },
      valide: {
        main: '#5da271',
        contrastText: '#FFF'
      },
      verdigris: {
        main: '#51B2A7',
        contrastText: '#FFF'
      },
      purple: {
        main: '#BF49A5',
        contrastText: '#FFF'
      },
      carmine: {
        main: '#96031A',
        contrastText: '#FFF',
        background: 'rgba(150, 3, 26, 0.5)'
      },
      grey: {
        main: '#BCC9C7', //rgb grey: 188, 201, 199
        contrastText: "#000"
      },
      dark: {
        main: '#000',
        contrastText: "#FFF"
      }
    },
    components:{
      MuiTableCell:{styleOverrides:{
        head: {
          backgroundColor: "#50787F",
          color: '#fff'
        },
        root:{
          fontSize:14
        }
      }},
      MuiTableRow: {styleOverrides:{
        root:{
          '&:nth-of-type(even)':{
            backgroundColor:"rgba(37, 87, 96, 0.05)"
          }
        },
      }}
    }
});

export default theme;